import BarGraphStacked from './bar-graph-stacked';

export default BarGraphStacked;
